import React from 'react';

import './FormHeader.scss';
import { FormHeaderProps } from './types';

const FormHeader: React.FC<FormHeaderProps> = ({ icon, title, subtitle }) => {
  return (
    <div className="form-header">
      <div className="form-header__icon">{icon}</div>
      <div className="form-header__title">{title}</div>
      <div className="form-header__subtitle">{subtitle}</div>
    </div>
  );
};

export default FormHeader;
